/**
 * AP 对账工作台路由调度
 *
 * 路由策略：
 *   /settlement/ap-workbench           → 工作台空状态，引导选择批次
 *   /settlement/ap-workbench?batch=XXX → 工作台页面 (WorkbenchPage)
 *
 * 将路由判断逻辑集中在一处，App.jsx 只需注册一条路由。
 */
import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Button, Empty } from "antd";
import WorkbenchPage from "./WorkbenchPage";

const WorkbenchRouter = () => {
    const [searchParams] = useSearchParams();
    const batchNumber = searchParams.get("batch");

    if (batchNumber) {
        return <WorkbenchPage />;
    }
    return (
        <div className="page-container">
            <div className="page-header-compact">
                <div className="page-title-compact">账单对账工作台</div>
            </div>
            <Empty description="请先从账单批次上传选择一个批次进入对账工作台">
                <Link to="/settlement/ap-batches">
                    <Button type="primary">前往账单批次上传</Button>
                </Link>
            </Empty>
        </div>
    );
};

export default WorkbenchRouter;
